import { render, staticRenderFns } from "./Paint.vue?vue&type=template&id=4d861538&scoped=true&"
import script from "./Paint.vue?vue&type=script&lang=js&"
export * from "./Paint.vue?vue&type=script&lang=js&"
import style0 from "./Paint.vue?vue&type=style&index=0&id=4d861538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d861538",
  null
  
)

export default component.exports